import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Header } from './components/Header';
import { ProductHero } from './components/ProductHero';
import { SalesCopy } from './components/SalesCopy';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#7E354D] selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <ProductHero data-id="element-4" />
        <SalesCopy data-id="element-5" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-gray-900 text-gray-400 py-12 text-center" data-id="element-6">
        <div className="max-w-7xl mx-auto px-4" data-id="element-7">
          <p className="mb-4" data-id="element-8">
            © 2026 ABA Sin Enredos. Todos los derechos reservados.
          </p>
          <p className="text-sm max-w-2xl mx-auto" data-id="element-9">
            Este producto no está afiliado, patrocinado ni respaldado por el
            Behavior Analyst Certification Board (BACB®). RBT® es una marca
            registrada del BACB®.
          </p>
        </div>
      </footer>
    </div>;
}